import React from 'react';

import {
  DescriptionList,
  DescriptionItem,
  Typography,
  HourglassEmptyIcon,
  Stack,
  CheckCircleIcon,
} from '@gogame/components';

import Approver from '../Approver';
import Status from '../Status';

const Metadata = ({ data }) => {
  return (
    <DescriptionList
      variant={'column'}
      data={data}
      stripEmpty={true}
      disableGutters={true}
    >
      <DescriptionItem
        label={'Status'}
        field={'status'}
        type={'status'}
        statusFactory={Status}
      />
      <DescriptionItem
        label={'Signing date'}
        field={'signDate'}
        type={'date'}
        template={'LLL'}
        timeZone={'utc'}
      />
      <DescriptionItem
        label={'Approvers'}
        field={'approvers'}
        type={'typographyList'}
        item={Approver}
      />
      <DescriptionItem
        label={'Signing by partner'}
        field={'signedByPublisher'}
        type={({ value }) => {
          return value ? (
            <Stack direction={'row'} spacing={1} alignItems={'center'}>
              <CheckCircleIcon sx={{ fontSize: 16 }} color={'success'} />
              <Typography>Signed</Typography>
            </Stack>
          ) : (
            <Stack direction={'row'} spacing={1} alignItems={'center'}>
              <HourglassEmptyIcon
                sx={{ fontSize: 16 }}
                style={{ color: '#838383' }}
              />
              <Typography>Not signed yet</Typography>
            </Stack>
          );
        }}
      />
      <DescriptionItem
        label={'Termination date'}
        field={'terminationDate'}
        type={'date'}
        template={'MONTH'}
        timeZone={'utc'}
      />
      <DescriptionItem
        label={'Last updated by'}
        type={'metadata'}
        value={data}
        userField={'updatedBy.name'}
        dateField={'updatedDate'}
      />
      <DescriptionItem
        label={'Created by'}
        type={'metadata'}
        value={data}
        userField={'createdBy.name'}
        dateField={'createdDate'}
      />
    </DescriptionList>
  );
};

export default Metadata;
